import { RootState } from '../index';
import { IconType } from './FMImagesReducer';

export const getIconsData = (state: RootState, iconsType: IconType) =>
    state.fmImages.icons[iconsType];
